
"use strict";

import * as twgl from 'twgl.js';
import * as rPic from './rpic';
import * as Tone from "tone";
import * as Stats from 'stats.js';
import { rControl, rNorm, writeNotice } from '../lib/control.js';
import rbus from '../objects/rbus';


/**GLOBAL DEBUG INFO ON WINDOW */
window.DivRT0 = window.parent.window.document.querySelector("#rt0");
window.DivRT1 = window.parent.window.document.querySelector("#rt1");
window.DivRT2 = window.parent.window.document.querySelector("#rt2");
window.DivRT3 = window.parent.window.document.querySelector("#rt3");

//rendiamo il Tone available ovunque!
window.parent.window.rTone = window.rTone = Tone;
//Durata iniziale del pezzo! Ricorda che il head sarà Tone.Transport.seconds!! 
Tone.Transport.rPos = { beg: 0, dur: 120, sec: 0, delay: 1, pos: 0 };

/**

 */
var PI = 3.141592654; // PI
var PI_2 = 1.570796327; // 1/2 PI



/**Commenti si o no! */
var rTComment=0;

/**Le traduzioni + inizializzazione*/
const rb=rbus;
rb.initTrans();

/**Parametri di controllo - visaluzzazione o meno di caratteristiche 
La variabile controllo, recuperabile da ovunque!!

QUAD, Component, WINDOW
c 0b000000001: TEST MODE;
c 0b000000010: il tempo va avanti;
c 0b000000100: camera roll automatica!;
c 0b000001000: feedback su canvas;
c 0b000010000: Commenti on /of;

AUDIO
a 0b000000000: ;
a 0b000000000: ;

VERTEX SHADER
v 0b00000000001: tutte le manipolazioni;
v 0b00000000010: audio data attivo;
v 0b00000000100: rilevazione colore webcam;
v 0b00000001000: rilievo z in base a brightness;
v 0b00000010000: coordinata z segue unde sin cos;
v 0b00000100000: drugi tipo de translate
v 0b00001000000: Spostamento in base a posizione centro isola (a_op);
v 0b00010000000: Rotazione quad;
v 0b00100000000: Look at centro oggetto;
v 0b01000000000: look at centro isola o rotazioneX in base a qualcosa;
v 0b00000000000: ;
v 0b00000000000: ;

FRAGMENT SHADER
f 0b00000000001: movimento webcam;
f 0b00000000010: webcam e fade;
f 0b00000000100: rilevazione audio RMS quando attivo;
f 0b00000001000: riflesso luci;
f 0b00000010000: isola corrente non corrisponde con l'isola scelta;

*/
var rToggler = window.parent.window.rToggler = {
	c: 0b010000110, //quad, 
	a: 0b00, //audio
	v: 0b0110000100000111, //Vertex shader
	f: 0b0000000,//fragment shader 
	//spiegazioni, vanno da 1 2 4 8 16...
	cs: [
		'Test mode',				// 1
		'Il tempo va avanti',		// 2
		'Camera roll automatica',	// 4
		'Feedback su canvas',		// 8
		'karkoli se ne ve se kaj', //16
		'mouse : movimento camera target', //32
		'mouse : movimento camera eye', //64
		'mouse : matrix movimento oggetto', //128
		'mouse : movimento camera around object' //256
	],
	as: [
		'BU?'
	],
	vs: [
		'tutte le manipolazioni', 									//	  1					   0001
		'rilievo quad in base a brightness',						//	  2					   0010
		'coordinata z segue onde sin cos',							//	  4					   0100 
		'rotazione quadrati attorno quadcenter',					//	  8					   1000
		'Look at centro isola',										//	 16				  0001 0000
		'Sferizzazione isola',										//   32				  0010 0000
		'axis rotazione quad verso centro isola', 					//	 64				  0100 0000
		'Rilevazione Audio - Bumb collina verso centro isola ', 	//  128			 	  1000 0000
		'Quando audio attivo eccita il quad',						//  256			 0001 0000 0000	
		'XX Spostamento in base a posizione centro isola (a_op)', 	//  512			 0010 0000 0000
		'XX Rotazione quad',										// 1024			 0100 0000 0000
		'XX Look at centro oggetto', 								// 2048			 1000 0000 0000
		'XX look at centro isola o rotazioneX in base a qualcosa',	// 4096		0001 0000 0000 0000
		'Quadrati che si ingrandiscono',							// 8192		0010 0000 0000 0000
		'Quadrati che si elevano',									//16384		0100 0000 0000 0000
		'XX',														//32768		1000 0000 0000 0000
	],
	fs: [
		'movimento webcam',
		'webcam e fade',
		'rilevazione audio RMS quando attivo',
		'riflesso luci',
		'Isola corrente non corrisponde all\'attuale',
		'Indicatore progresso sonoro'
	],
	isles: [0, 0], //numero di isole, isola scelta!
	//FUNCTIONS!!!
	ff: {
		/**Da 0->1!! */
		irregularWave: function(time, frequency, x = 1, a = 2.1, b = 1.71, c = 2.221, d = 3.1122) {
			let t = 0.01 * (-time * 130);
			let y = Math.sin(x * frequency);
			y += Math.sin(x * frequency * a + t) * 4.5;
			y += Math.sin(x * frequency * b + t) * 4.0;
			y += Math.sin(x * frequency * c + t) * 5.0;
			y += Math.sin(x * frequency * d + t) * 2.5;
			return y * 0.06;
		}
	}
}



var rFade = function(x, begin, end, startvalue, endvalue) {
	if (x <= begin) {
		return startvalue;
	}
	else if (x >= end) {
		return endvalue;
	}
	else {
		let t = end - begin; //tempo totale
		let n = x - begin; //posizione in seno al tempo totale
		let norm = n / t; //normalizzazione della posizione (0->1) che serve per la funzione sin sotto
		let diff = endvalue - startvalue; //la differenza fra valore da raggiunfgere ed inizio
		if (startvalue > endvalue) {
			//Formula s inversa orizzontalmente: t(x)=((1)/(1+4^(8 x-4)))
			return endvalue - diff * (Math.cos(PI * norm) / 2 + .5);
			//			return (Math.sin(PI_2 * norm + PI_2));
		} else {
			//Formula s inversa verticalmente: f(x)=-((ln(256 (((1)/(x))-1)))/(16 ln(2)))+1

			return startvalue + diff * (Math.cos(PI * norm + PI) / 2 + .5);
			//			return -((Math.log(256 * (((1)/(x))-1)))/(16 * Math.log(2)))+1;

			//			let X = (norm - .5) / 4;
			//			if (X >= 0) {
			//				return .5 + Math.pow(X, .333333);
			//			}
			//			else {
			//				return .5 - Math.pow(-X, .333333);
			//			}
			//			return norm*norm*norm;
			//			return (1+Math.sin(PI_2*norm-PI_2));
		}
	}
}

/**
from array A to B: SPEED LINEAR!
transforms INPLACE array A so that it approaches values in array B
speed: da 0>1!;
*/
var rTowards1 = (A, B, Speed = .1) => {
	//se le due array non sono di stessa lunghezza ritorna false, altrimenti esegue procedura e ritorna true
	if (A.length !== B.length) return false;

	//approach lineare
	for (let i = 0; i < A.length; i++) {
		let a = A[i];
		let b = B[i];

		let d = b; //destinazione

		if (a < b) {
			d = a + Speed;
			if (d > b) d = b;
		}
		if (a > b) {
			d = a - Speed;
			if (d < b) d = b;
		}

		//ci avviciniamo alla distanza
		A[i] = d;
	}
	return true;
}

/**
From array A to B halving the distance each round. Devono avere lo stesso numero di elementi! 
 */
var rTowards0 = (A, B, Speed = .5) => {
	//se le due array non sono di stessa lunghezza ritorna false, altrimenti esegue procedura e ritorna true
	if (A.length !== B.length) return false;

	//approach lineare
	for (let i = 0; i < A.length; i++) {
		let di = (B[i] - A[i]) * Speed;

		//ci avviciniamo alla distanza
		A[i] += di;
	}
	return true;
}




/*
 * l'oggetto picture eee
 * ATTENTION! non carica i shaders o l'immagine ma li recupererà già pronti!
 */
var rQuad = {

	sizes: {//le grandezze
		nx: 110, //number of elements x
		ny: 110, //nr elements y
		dimX: 10, //width
		dimY: 10, //height
	},
	sources: {//shaders,
		canvas_element: "", //il canvas id che contraddistingue dove disegneremo il presente oggetto
		vSource: "", //vertex shaderSource, la String dello shader
		fSource: "", //fragment shaderSource, la String dello shader
	},
	parameters: {//i parametri in entrata che fanno cambiare il rendering
		iData: {}, //tutti i dati recuperati dall'immagine: canvas, immmagine, oggetti etc. etc.
		// Ogni oggetto Incorporerà i seguenti
		// {
		// bufferInfo: [],
		// materials: [],
		// matrices: [],
		// models: []
		// }, //gli oggetti che andremo a creare: oggetti, matrici, materiali
		vue: {}, //il vue del parent!!
		control: {},
		rendercont: { //parametri control
			radius: 26, //raggio eye -> centro oggetto
			fak: 5, //fattore di ingrandimento
			//parametri da inserire nella matrice
			eyetrack: [0, 0, 0], //posizione finale del punto di vista in base al tracker: x,y,z, rotx, roty, rotz, 
			eyemouse: [0, 0, 0], //posizione finale del punto di vista in base al movimento mouse: x,y,z, rotx, roty, rotz,
			eyegest: [0, 0, 0], //posizione finale del punto di vista in base alla gesture cellulare: x,y,z, rotx, roty, rotz,
			targettrack: [0, 0, 0], //posizione finale del target in base al tracker: x,y,z, rotx, roty, rotz, 
			targetmouse: [0, 0, 0], //posizione finale del target in base al movimento mouse: x,y,z, rotx, roty, rotz,
			targetgest: [0, 0, 0], //posizione finale del target in base alla gesture cellulare: x,y,z, rotx, roty, rotz,
			objecttrack: [0, 0, 0], //posizione finale del object in base al tracker: x,y,z, rotx, roty, rotz, 
			objectmouse: [0, 0, 0], //posizione finale del object in base al movimento mouse: x,y,z, rotx, roty, rotz,
			objectgest: [0, 0, 0], //posizione finale del object in base alla gesture cellulare: x,y,z, rotx, roty, rotz,
			objectposition: [0, 0, 0], //posizione finale delll'oggetto: x,y,z
			objectrotation: [0, 0, 0], //rotazione finale delll'oggetto: rotx, roty, rotz,
			objectmatrix: twgl.m4.identity(), //matrice oggetto finale
			eyematrix: twgl.m4.identity(), //matrice occhio finale
			temp: [0, 0, 0, 0, 0, 0, 0], //per le operazioni di avvicinamento
			eye: [0, 0, 0], //
			target: [0, 0, 0]

		}, //i controller vari!

		wc: {
			videoData: {
				videoel: {}, //the video element
				canv: [], //some convases whe need for data manipulation
				ctx: [], //the video contexts of the canvases
				frame: [], //the ctxes ImageData: 0,1,2
				crect: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0], //webcam color track position data (il nBond del tracker colore) [6]-> distanza lato
				nrect: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0], //normalized rect 0->1, webcam data (dato finale distanza lato)
				npos: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0], //position of the pointer towards direction (dato finale distanza dai due vertici)
				ilist: [] //lista di coordinate interessanti (in questo caso quelle rilevate come spostamento dalla webcam) in forma [x0,y0,x1,y1,x2,y2...]
			}
		}, //webcam Data
		globals: {
			clock: {
				then: 0,
				fade_A: {}, //sarà il tone.signal che userai per il fade in e oud del tempo
				//moltiplicato per tone.seconds ti darà il fade del timing
				fade_B: {} //tone.signal che influisce su tutto

			}, //i paramatri per il controllo del flusso!
			time: 0, //uniform! tempus scorrit
			then: 0, //per il timer
			PI: 3.141592654, // PI
			PI_2: 1.570796327, // 1/2 PI
			PI2: 6.283185307, // 1/2 PI
			PI3: 9.424777961, // 3*PI
			PI4: 12.566370614, // 4*PI
			gl: Object, //il gl object, context del canvas
			el: Object, //elemento Canvas che viene recuperato da sources.canvas_element
			first: true, //un trigger per cose fatte partire una sola volta
			eyehistory: [0, 0, 0], //posizione da tenere in considerazione per la matrix che sposta l'eye in base a mouse
			trackhistory: [0, 0, 0], //posizione da tenere in considerazione per la matrix che sposta l'eye in base a tracking
			random_vector4: [], //un insieme di vettori random che possono essere utili
			texbuffer: [], //il buffer per la float texture
			p_temp: [], //temporary position di servizio
			isRunning: false, //indica quando il render fa partire requestanimationframe
			//			trasnportID: Number, //indica l'id dello scheduled event del trasnport
			initialized: false, //indica se è già stato inizializzato
			LatLong: [0, 0], //latitude and longitude of the camera view!!
			temp: [0, 0, 0, 0, 0], //temporary variables
		},
		uniforms: {
			//
			durata: 0, //intera durata in secondi
			//textures
			tex1: {}, //slika
			tex2: {}, //webcam
			texf1: {}, //data texture
			texf2: {}, //data texture
			texf3: {}, //data texture

			//time
			time: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], //10 parametri tempo che si muovono diversamente;
			period: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],//20 diversi parametri periodo
			fade: [0, 0, 0, 0, 0], //5 parametri fade diverse, legate all'oggetto tone.signal in genere
			//twgl params
			world: {
				viewInfo: {},
				viewProjection: {},
				viewInverse: {},
				numberOfLights: 1,
				lightInfos: [],
			}, //creato automaticamente da twgl nell'init
			material: {}, //l'uniform block del materiale per gli oggetti. uno per tutti
			model: {} //l'uniform block degli oggetti
			//ricorda differenza oggetti (insiemi di pixels per non eccedere numero) e isles (isole: isole di colore)
		},
		programInfo: {

		}, //il programma
		stats: { //le statistiche!!

		}
	},
	/**
	 * inizializza e fa partire l'inizializzatore 
	 * Richiede stringhe degli shaders, id del canvas e url dell'immagine!
	 * @param {type} canvas_element - stringa dell'Id del canvas
	 * @param {type} imageUrl - url immagine
	 * @param {type} vertexShader - le stringhe complete degli shader!
	 * @param {type} fragmentShader
	 * @param {type} width (numero elementi per i quad W)
	 * @param {type} height (numero elementi per i quad H)
	 * @param {type} dimx (dimensioni finali)
	 * @param {type} dimy (dimensioni finali)
	 * @returns {undefined}
	 */
	setSourcesAndInit: function(canvas_element, imageUrl, vertexShader, fragmentShader, width = 100, height = 70, dimx = 10, dimy = 10, duration = 120) {
		this.sizes.nx = width;
		this.sizes.ny = height;
		this.sizes.dimX = dimx;
		this.sizes.dimY = dimy;
		this.sources.canvas_element = canvas_element;
		this.sources.vertexShader = vertexShader;
		this.sources.fragmentShader = fragmentShader;
		const app = this;

		if (rTComment)  console.log('rquad sources init: ' + imageUrl);

		//RECUPERATO la instance dello vue del documento che contiene l'iframe!!
		this.parameters.vue = window.parent.parent.app.__vue__;

		rPic.getImageData(imageUrl, width, height, dimx, dimy).then(function(resp) {
			//facciamo partire lo shader

			if (rTComment)  console.log('rquad rpic init: ' + imageUrl);

			//Impostata la durata in base allo standard
			Tone.Transport.rPos.dur = duration;

			/*
			 * i dati glesData sono organizzati in array (che rappresenta il singolo oggetto) di array gl
			 * colors (float32array di colors etc etc.)
			 * indices
			 * normal
			 * ocenter
			 * position
			 * qcenter
			 * texcoord
			 * 
			 */
			app.init(resp);

			// if (rTComment)  console.log(resp);
			//una volta caricati tutti i files facciamo partire la cosa!
			// if (rTComment)  console.log('go!');
		}).catch(function(resp) {
			if (rTComment)  console.log(resp);
			alert("Could not load Image: " + resp);
		});
	},
	/**
	 * Inizializza l'oggetto,in entrata i dati dell'oggetto
	 * 
	 * 
	 * */
	init: function(iData) {

		if (rTComment)  console.log('rquad app init');

		//SCORCIATOIE
		//SCORCIATOIE
		const app = this;

		twgl.setDefaults({ attribPrefix: "a_" });
		const m4 = twgl.m4;
		this.parameters.iData = iData; //trasferiti gi dati immagine per utilizzo successivo

		let un = this.parameters.uniforms; //uniforms!
		const world = un.world; //scorciatoia per il mondo

		const objectData = this.parameters.iData.objectData; //scorciatoia per l'array oggetti
		//scorciatoia alle info objectdata (numero isole, grandezze etc.)
		let info = objectData.info;

		//durata della sequenza: Tone.Transport.rPos.dur;

		//STATS
		//STATS
		if (rToggler.c & 0b01) { //il parametro di controllo che trovi in app.js -> rToggler e che si propaga ovunque ci sia vue
			this.parameters.stats = new Stats();
			this.parameters.stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
			window.document.body.appendChild(this.parameters.stats.dom);
		}
		//		window.parent.window.document.body.appendChild(this.parameters.stats.dom);
		//STATS
		//STATS

		//TIME
		//TIME

		//		this.animationInit();

		//TIME
		//TIME


		//WEBCAM
		//WEBCAM
		let wc = this.parameters.wc = window.parent.window.wc;

		///Inizializziamo gli id isola nella webcam data
		wc.setIsleData(iData.imageData);


		//		if (rTComment)  console.log(this.parameters.wc);
		//WEBCAM
		//WEBCAM

		//SETTING SOME PARAMETERS
		//SETTING SOME PARAMETERS

		this.parameters.rendercont.fak = this.parameters.globals.PI;

		//SETTING SOME PARAMETERS
		//SETTING SOME PARAMETERS



		//debug: display fps div
		const el = this.parameters.globals.el = document.getElementById(this.sources.canvas_element);


		//GLGLGLGLGLGLGLGLGLGLGLGLG
		//recuperata destinazione del gl
		const gl = this.parameters.globals.gl = twgl.getContext(el);
		//SCORCIATOIE
		//SCORCIATOIE

		//     	const extensions = gl.getSupportedExtensions();
		//     	
		//     	if (rTComment)  console.log(`GLES EXTENSIONS`,extensions);
		//     	
		//		if (extensions.indexOf("GL_OES_texture_npot") != -1){
		//			alert("something wrong");
		//		};

		if (!twgl.isWebGL2(gl)) {
			let h = rb.tranz.gl2err;
			let el = window.parent.document.getElementById('r-content');
			let p = rb.tranz.gl2err_e;
			if (h === undefined) {
				h = "Compatibility error";
				p = "Sorry, this example requires WebGL 2.0";
				//				alert("Sorry, this example requires WebGL 2.0"); // eslint-disable-line	
			}
			writeNotice(el, h, p);
			return;
		}


		if (rTComment)  console.log('maxtexturesize: ' + gl.MAX_TEXTURE_SIZE);

		//PARTE GENERALE
		//PARTE GENERALE
		//il programma
		//		let nn = iData.objectData.islands.length;
		//		nn = 100;
		//
		//		//CAMBIO length degli array per accogliere le stats islands
		//		this.sources.vertexShader = this.sources.vertexShader.replaceAll('MAX_METER', nn);
		//		this.sources.fragmentShader = this.sources.fragmentShader.replaceAll('MAX_METER', nn);


		//UTILIZZO DEI CONTEST PER TEXTURE FLOAT!!
		//		gl.getExtension('OES_texture_float');
		//		gl.getExtension('OES_texture_float_linear');
		twgl.addExtensionsToContext(gl);

		//program Info		
		const programInfo = this.parameters.programInfo = twgl.createProgramInfo(gl, [this.sources.vertexShader, this.sources.fragmentShader]);


		//textures
		un.tex1 = twgl.createTexture(gl,
			{
				min: gl.NEAREST,
				mag: gl.NEAREST,
				src: iData.imageCanvas
			});

		un.tex2 = twgl.createTexture(gl,
			{
				min: gl.NEAREST,
				mag: gl.NEAREST,
				src: iData.imageCanvas
			});


		//la float texture che fornisce dei dati del quadro
		un.texf1 = twgl.createTexture(gl,
			{
				internalFormat: gl.RGBA32F,
				format: gl.RGBA,
				type: gl.FLOAT,
				src: objectData.texf1, //il buffer dati
				width: 3 //3*8, 16 floats
			});

		//			if (rTComment)  console.log('kkk',objectData.texf1);

		un.texf2 = twgl.createTexture(gl,
			{
				internalFormat: gl.RGBA32F,
				format: gl.RGBA,
				type: gl.FLOAT,
				src: objectData.texf2, //il buffer dati
				width: 2 //4*8, 32 floats
			});

		un.texf3 = twgl.createTexture(gl,
			{
				internalFormat: gl.RGBA32F,
				format: gl.RGBA,
				type: gl.FLOAT,
				src: objectData.texf3, //il buffer dati
				width: 3 //4*8, 32 floats
			});
		//FLOAT TEXTURES


		//uniforms generiche che non cambieranno nel tempo
		//uniforms generiche che non cambieranno nel tempo

		un.durata = Tone.Transport.rPos.dur; //durata in secondi del tutto

		//[4 dati] grandezza dell'oggetto w/h, diagonale, distanza massima pixel->centro isola;
		un.info1 = [info.ow, info.oh, info.imageDiagonal, info.maxDistance];

		//[5 dati] isole: numero minimo, massimo elementi, numero totale di elementi, numero isole, isola scelta
		un.info2 = [info.minels, info.maxels, info.allels, info.numIslands, 0];

		//altri dati

		//rendiamo noto il numero di isole e selezioniamo la prima
		rToggler.isles = [info.numIslands, 0];

		//uniforms generiche che non cambieranno nel tempo
		//uniforms generiche che non cambieranno nel tempo

		//adds various extensions to contest! (fra cui OES_texture_float OES_texture_float_linear )

		//POINT OF VIEW
		world.viewInfo = twgl.createUniformBlockInfo(gl, programInfo, "View"); //uniform blocks
		world.viewProjection = world.viewInfo.uniforms.u_viewProjection || new Float32Array(16); //parameters per uniform
		world.viewInverse = world.viewInfo.uniforms.u_viewInverse || new Float32Array(16); //parameters per l'uniform
		twgl.setUniformBlock(gl, programInfo, world.viewInfo);
		//END POINT OF VIEW

		//LIGHTS
		world.lightInfos = []; //luci
		for (let ii = 0; ii < world.numberOfLights; ii++) { //due per ora, come i materiali e gli oggetti (attenzione che gli oggetti pescano da questi array per materiale, luci)
			const lightUbo = twgl.createUniformBlockInfo(gl, programInfo, "Lights[" + ii + "]");
			twgl.setBlockUniforms(lightUbo, {
				u_lightColor: [1.0, 1.0, 1.0, 1.0],
				u_lightWorldPos: [0, 0, 20] //posizione delle luci
			});
			twgl.setUniformBlock(gl, programInfo, lightUbo);
			world.lightInfos.push(lightUbo);
		}
		//END LIGHTS

		//MATERIALE QUADRO INTERO
		un.material = twgl.createUniformBlockInfo(gl, programInfo, "Material");
		twgl.setBlockUniforms(un.material, {
			u_ambient: [.1, .1, .1, 1],
			u_specular: [.9, .9, .9, 1],
			u_shininess: 200,
			u_specularFactor: 0.3
		});
		twgl.setUniformBlock(gl, programInfo, un.material);
		//END MATERIALE QUADRO INTERO

		//MODEL UNIFORMS - esterni poichè uguali per tutti gli oggetti!
		un.model = twgl.createUniformBlockInfo(gl, programInfo, "Model");
		const temp_world = m4.identity();
		const temp_worldInverse = m4.transpose(m4.inverse(temp_world));
		twgl.setBlockUniforms(un.model, {
			u_world: temp_world,
			u_worldInverseTranspose: temp_worldInverse,
			u_durata: Tone.Transport.rPos.dur
		});
		twgl.setUniformBlock(gl, programInfo, un.model);
		//END MODEL UNIFORMS

		//END PARTE GENERALE
		//END PARTE GENERALE

		//		if (rTComment)  console.log(un);

		//OGGETTI
		//OGGETTI

		//oggetti
		const N = objectData.islands.length;


		/**
		TEXTURE POSIZIONI
		
		Array di posizioni xyzw!!
		Il texture in proposito propone la posizione relativa dell'oggetto: xyz E la posizione precedente 
		(per avere la direzione nello shader)!
		
		[0..3]: posizione corrente 
		[4..8]: dato precedente!
		
		 */
		objectData.texObPos = new Array(N * 8);

		//inizializziamo i buffer objects dagli oggetti in entrata
		objectData.oggetti.forEach(function(ob, key) {

			let dt = {}; //dati oggetto

			//aggiungiamo gli attributi dell'oggetto
			dt.bufferInfo = (twgl.createBufferInfoFromArrays(gl, ob));

			//raggruppiamo gli elementi ernderizzabili nell'oggetto glsBlock
			ob.glsBlock = dt;


		});
		//END OGGETTI
		//END OGGETTI

		//il cono visualizzato da sparare nella matrix! 		
		this.parameters.globals.projection = m4.perspective(30 * Math.PI / 180, gl.canvas.clientWidth / gl.canvas.clientHeight, 0.1, 420);

		//distanza predefinita eye->target di radius;
		this.parameters.rendercont.eye[2] = this.parameters.rendercont.radius;

		//altri parametri mutevoli

		this.parameters.control = rControl;
		this.parameters.control.init(this.parameters.globals.el);

		// 
		//		this.render();

		//l'evento che notifica l'avvenuta inizializzazione del transport!
		const rEvent = new Event('transport_init');
		window.parent.window.dispatchEvent(rEvent); //evento lanciato nella finestra madre

		/**PARTE CHE SI OCCUPA DEL LOADER, BUTTON START etc. */
		/**PARTE CHE SI OCCUPA DEL LOADER, BUTTON START etc. */

		app.loaderOff();

		/**Ad inizializzazione il oader è già visibile! */

		//ADDING KEY EVENT LISTENER
		window.parent.document.addEventListener('keydown', (event) => {
			let apps = rQuad;
			switch (event.key) {
				case "c": //C - Camera roll
					//https://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
					//bitwise toggle bit!
					rToggler.c ^= 1 << 2;
					break;
				case "f": //F
					let elem = window.parent.document.getElementById("gl-frame");

					if (elem.requestFullscreen) {
						elem.requestFullscreen();
					} else if (elem.webkitRequestFullscreen) {
						/* Safari */
						elem.webkitRequestFullscreen();
					} else if (elem.msRequestFullscreen) {
						/* IE11 */
						elem.msRequestFullscreen();
					}
					break;
				case "r": //R restart
					apps.animationReset();
					break;
				case "s": //S stop
					apps.animationStop();
					apps.loaderOn();
					apps.loaderOff();
					break;
				case "p": //P pause
					apps.animationPause();
					break;
			}
		});


		/**PARTE CHE SI OCCUPA DEL LOADER, BUTTON START etc. */
		/**PARTE CHE SI OCCUPA DEL LOADER, BUTTON START etc. */

	},
	/**Imposta il startbutton sostituendo l'animazione del loader*/
	loaderOff() {
		let startbutton = window.parent.document.getElementById("rstart");
		let rimageloader = window.parent.document.getElementById("rimageloader");

		rimageloader.style.animation = "fadeOut 2s forwards";

		startbutton.style.animation = "fadeIn 2s forwards";
		startbutton.onclick = this.startButtonPress;
		startbutton.style.cursor = "pointer";
	},
	/**Fade in dell'intero loader sulla pagina */
	loaderOn() {
		//fadeIn del loader
		let loader = window.parent.document.getElementById("r-loader");
		loader.style.animation = "fadeIn 2s forwards";

		let rimageloader = window.parent.document.getElementById("rimageloader");
		rimageloader.style.animation = "fadeIn 1s forwards";
		let startbutton = window.parent.document.getElementById("rstart");
		startbutton.style.animation = "fadeOut 1s forwards";
		startbutton.onclick = null;
		startbutton.style.cursor = "default";
	},
	/**Funzione che disattiva il loader e fa partire l'animazione*/
	startButtonPress() {
		let app = rQuad;
		let loader = window.parent.document.getElementById("r-loader");
		let startbutton = window.parent.document.getElementById("rstart");

		//fade out loader
		loader.style.animation = "fadeOut 2s forwards";

		//disattivazione onclick del bottone
		let elem = window.parent.document.getElementById("gl-frame");

		/**Fullscreen after 2 secs.!!*/
		setTimeout(() => {
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.webkitRequestFullscreen) {
				/* Safari */
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) {
				/* IE11 */
				elem.msRequestFullscreen();
			}
			startbutton.onclick = null;
			startbutton.style.cursor = "default";
			app.animationInit();
			app.animationStart();

		}, 2000);

	},
	/*Inizializza gli eventi del trasnport cancellando i precedenti*/
	animationInit() {

		let un = this.parameters.uniforms; //uniforms!

		//resettiamo l'inizio della sequenza'
		this.parameters.globals.first = true;

		this.parameters.globals.initialized = true;
		this.parameters.globals.clock.starting = true; //controllo per la prime esecuzione!
		this.parameters.globals.clock.counter = 0; //il counter

		//mettiamo nella posizione richiesta i secondi del transport! 
		Tone.Transport.seconds = Tone.Transport.rPos.sec = 0;
		Tone.Transport.rPos.pos = 0;

		Tone.start();
		Tone.Transport.cancel();
		Tone.Transport.stop();

		if (rTComment)  console.log('Animation Init');


		//TIME PARAMETERS
		//TIME PARAMETERS
	},
	/**starts over the animation*/
	animationStart() {
		let app = this;
		Tone.Transport.start();

		if (!app.parameters.globals.isRunning) {
			app.parameters.globals.isRunning = true;
			requestAnimationFrame(app.render.bind(app)); //facciamo partire l'animazione
		}
		if (rTComment)  console.log(`Animation Start transport.seconds: ${Tone.Transport.seconds}`);
	},

	animationStop() {
		let app = this;
		app.parameters.globals.isRunning = false;
		Tone.Transport.cancel();
		Tone.Transport.stop();
		Tone.Transport.seconds = Tone.Transport.rPos.sec = 0;
		Tone.Transport.rPos.pos = 0;
		//resettiamo i dati texture audio
		window.texData.fill(0);
		if (rTComment)  console.log(`Animation Stop transport.seconds: ${Tone.Transport.seconds}`);
		//EXIT FULLSCREEN
		let doc = window.parent.document;
		if (doc.fullscreenElement !== null) {
			if (doc.exitFullscreen) {
				doc.exitFullscreen();
			} else if (doc.webkitExitFullscreen) {
				/* Safari */
				doc.webkitExitFullscreen();
			} else if (doc.msExitFullscreen) {
				/* IE11 */
				doc.msExitFullscreen();
			}
		}
	},
	/**Pauses animation */
	animationPause() {
		let app = this;
		//https://stackoverflow.com/questions/1436438/how-do-you-set-clear-and-toggle-a-single-bit-in-javascript
		//bitwise toggle bit!
		//		app.parameters.globals.isRunning = false;
		rToggler.c ^= 1 << 1;
		if (rToggler.c & 0b10) {
			if (rTComment)  console.log(`Animation Pause transport.seconds before start: ${Tone.Transport.seconds}`);
			Tone.Transport.start();
			//			app.parameters.globals.isRunning = true;
			if (rTComment)  console.log(`Animation Pause transport.seconds after start: ${Tone.Transport.seconds}`);
		} else {
			if (rTComment)  console.log(`Animation Pause transport.seconds before pause: ${Tone.Transport.seconds}`);
			Tone.Transport.pause();
			//			app.parameters.globals.isRunning = false;
			if (rTComment)  console.log(`Animation Pause transport.seconds after pause: ${Tone.Transport.seconds}`);
		}

	},
	/**Resumes playing after pause */
	animationResume() {
		let app = this;
		app.parameters.globals.isRunning = true;
		if (rTComment)  console.log(`Animation Resume transport.seconds: ${Tone.Transport.seconds}`);
		Tone.Transport.start();
		requestAnimationFrame(app.render.bind(app)); //facciamo partire l'animazione

	},
	/**resetta i secondi del transport */
	animationReset() {

		Tone.Transport.seconds = 0;
		Tone.Transport.rPos.sec = 0;
		Tone.Transport.rPos.pos = 0;
		//resettiamo i dati texaudio
		window.texData.fill(0);

		if (rTComment)  console.log(`Animation Reset transport.seconds: ${Tone.Transport.seconds}`);
	},


	/**
	 * da richiamare nello rendering dell'oggetto
	 * @returns {undefined}
	 */
	render: function(now) {

		/**Statistiche nel caso siamo in testing mode*/
		if (rToggler.c & 0b01) this.parameters.stats.begin();

		const param = this.parameters;
		const globals = param.globals;
		const isRunning = globals.isRunning;
		const app = this;


		//il tempo va avanti rToggler.c: 0b10
		if (rToggler.c & 0b10) Tone.Transport.rPos.sec = Tone.Transport.seconds; //synced time

		let pos = Tone.Transport.rPos.pos = Tone.Transport.rPos.sec * Tone.Transport.rPos.delay;


		let dur = Tone.Transport.rPos.dur; //durata


		if (typeof now != 'undefined') {

			const m4 = twgl.m4; //scorciatoia per m4
			const tt = this.parameters.control;
			const mouseController = tt.mouse;
			const objectData = param.iData.objectData;
			const un = param.uniforms;
			const gl = globals.gl;
			const world = param.world;
			const programInfo = param.programInfo;
			const PI = globals.PI;
			const PI2 = globals.PI2; // 1/2 PI
			const PI3 = globals.PI3; // 1/2 PI
			const ct = param.rendercont; //controls!

			const wc = param.wc; //webcam
			const vd = wc.videoData; //webcam videodata
			//la posizione che deriva dalla webcam! [4]: x del centro, [5]: y del centro, [6]: distanza degli estremi

			const v3 = twgl.v3;
			// now *= 0.001; //converting time to seconds!

			//raggio eye->centro oggetto!
			let rd = ct.radius + ct.radius * mouseController.magn;


			if (globals.first) //evento primo e unico 
			{
				Tone.Transport.seconds = 0;
				//				alert('First');

				globals.first = false;
				//HIDE LOADER

				//VARIE
				globals.p_temp = [Math.random() * 5 + 5, Math.random() * 3 + 3, Math.random() * 4 + 2, Math.random() * 4 + 2]; //target temporaneo;

				//				Tone.getDestination().volume.value = -Infinity;
				//				Tone.getDestination().volume.rampTo(5, 4, 2);
				//				Tone.getDestination().volume.rampTo(-Infinity, 4, dur - 4);
				//				globals.audio=new Tone.FMSynth().toDestination();
				//				globals.audio.triggerAttack("C3");
				//				globals.temp[0]=0;

				/**EYE AND TARGET!!*/
				//eye
				ct.eye = [0, 0, rd];
				//target
				ct.target = [0, 0, 0];


			}

			let fade = un.fade;

			/*now, begin, end, startvalue, endvalue */
			/*
			FADE
			0: fade in out immagine
			1: fade in out effetti shader + audio
			2: fade in out camera
			 */
			fade[0] = rFade(pos, .5, 3, 0, 1); //fade in!!
			fade[0] = rFade(pos, dur - 4, dur - 1, fade[0], 0); //fade out!!

			fade[1] = rFade(pos, 4, 8, 0, 1); //fade in!!
			fade[1] = rFade(pos, dur - 8, dur - 4, fade[1], 0); //fade out!!


			fade[2] = rFade(pos, 8, 35, 0, 1); //fade in!!
			fade[2] = rFade(pos, dur - 20, dur - 8, fade[2], 0); //fade out!!

			fade[3] = rFade(pos, .5, 3, 0, 1); //fade in!!
			fade[3] = rFade(pos, dur - 4, dur - 1, fade[3], 0); //fade out!!

			fade[4] = rFade(pos, .5, 3, 0, 1); //fade in!!
			fade[4] = rFade(pos, dur - 4, dur - 1, fade[4], 0); //fade out!!

			//Durante il fade in/fade out
			if (fade[1] < 1 && fade[0] > 0) {
				Tone.getDestination().output.gain.value = fade[1];
				if (rTComment)  console.log(`FADI IN OUT Process: ${fade[1].toFixed(2)}`);
			}
			//Durante il fadeout iniziale




			//TIME
			//TIME
			let time = un.time;

			time[0] = pos;

			/** time[1] indica lo scorrere da 0->1 per l'intera durata prevista*/
			time[1] = pos / dur;

			let t = 2
			//diverse tempistiche
			for (let i = 1; i <= 8; i++) {
				un.time[t] = (pos * Math.pow(i, 3) * 0.01) * t++;
			}
			//TIME
			//TIME

			//PERIOD
			//PERIOD
			//Peridoi 0->4 SIN da -1 a 1
			//periodi 5->9 COS da -1->1
			//Periodi 10->14 SIN da 0 a 1
			//Periodi 15->19 COS da 0 a 1
			let period = un.period;

			//da -1 a 1
			period[0] = Math.sin(pos);
			for (let i = 1; i < 5; i++) {
				period[i] = Math.sin(pos * (i * i * .001));
			}
			period[5] = Math.cos(pos);
			for (let i = 6; i < 10; i++) {
				period[i] = Math.cos(pos * (i * i * .001));
			}
			//da 0->1, prima sin poi cos
			for (let i = 10; i < 19; i++) {
				period[i] = period[i - 10] * 0.5 + 0.5;
			}


			//			Tone.getDestination().volume.value=-100*period[10];
			//			if (rTComment)  console.log('vloume',Tone.getDestination().volume.value);

			//PERIOD
			//PERIOD

			//tempo del frame
			//			tt.t1("time 9: " + un.time[9].toFixed(2));


			//Il tempo dell'audio context!
			// const a_time = param.iData.imageData.audioCtx.currentTime;

			//			if (parseInt(t) % 1 == 0) {
			if (wc.grabData(param.vue.glpic.slid)) { //se il processo di recuperare il'immagine webcam è ok allora procedi'
				twgl.setTextureFromArray(gl,
					un.tex2,
					vd.frame[1].data, {
					min: gl.NEAREST,
					mag: gl.NEAREST,
					width: 320
				});
				//la texture con i dai derivati da analisi webcam
			} else {
				twgl.setTextureFromArray(gl,
					un.tex2,
					[0, 0, 0, 0], {
					min: gl.NEAREST,
					mag: gl.NEAREST,
					width: 1
				});
			}

			//FLOAT DATA TEXTURE FOR AUDIO
			//FLOAT DATA TEXTURE FOR AUDIO
			//la float texture che ci servirà per i dati!
			//fill(valore, inizio, fine) senza fine riempie dall'inizio.
			//Audio data nella texture texd!!

			//I DATI DALLA WEBCAM - ISLANDS ATTIVATE
			//			if (rTComment)  console.log('wc0',objectData.wcdata);
			//			objectData.islandsWebcamData(this.parameters.wc.videoData.ilist);
			//			if (rTComment)  console.log('wc1',objectData.wcdata);

			//Recuperiamo i dati del cambiamento dalla webcam!!!
			//ilist: lista di indirizzi dei pixel rilevati
			//			objectData.islandsWebcamData(wc.videoData.idList);

			//si processano le liste di ID del grab video
			objectData.wcData(wc.videoData.idList, wc.videoData.crList);

			//si processano le singole islands: time 1 da 0->1
			objectData.go(time[1]);

			//			try {
			//				
			//				let a,b,c,d;
			//				
			//				let n=(rToggler.isles[0]+1)/(rToggler.isles[1]+1);
			//				let rd=globals.PI/360;
			//				
			//				/**irregularWave(time, frequency, x = 1, a = 2.1, b = 1.71, c = 2.221, d = 3.1122) */
			//				a = 2.1; b = 1.71; c = 2.221; d = 3.1122;
			//				temp[1] = rToggler.ff.irregularWave(time[0], 100, temp[0],a,b,c,d);
			//				a = 2.1; b = 1.71; c = 2.221; d = 3.1122;
			//				temp[1] = rToggler.ff.irregularWave(time[0], 50, temp[0],3,2,1,0);
			//				
			//				globals.audio1.frequency.value=120+100*temp[1];
			//				let t=time[0]*.5;
			//				cw = rToggler.ff.irregularWave(t, 100, 10*Math.sin(t*.001),2*(rToggler.isles[0]+1)/(1+rToggler.isles[1]));
			//				globals.audio2.frequency.value=120+100*cw;
			//				globals.audio2.harmonicity.value = 2*time[0];
			//				
			//				if ((temp[0]+=rd)>globals.PI) temp[0]=0;
			//
			//			} catch (e) {
			//				if (rTComment)  console.log(e);
			//			}


			//NO SERVI LA FUNKCIJA ZGORAJ ZE STAVI V TEXTURE PODATKE!!!
			//			objectData.islands.forEach((ob, k) => {
			//				/**per ogni oggetto esiste una riga che corrisponde al suo id che
			//				incorpora i dati dell'eccitazione webcam: mossa ed eventuale audio*/
			//
			//				td.push(...ob.texOutput);
			//
			//			});

			try {
				var texd = twgl.createTexture(gl,
					{
						internalFormat: gl.RGBA32F,
						format: gl.RGBA,
						type: gl.FLOAT,
						src: window.texData,
						//						width: 9 //4*9, 36 floats
						width: 1 //4 floats
					});
				//					if (rTComment)  console.log('kaj bo to 1',objectData.texData.length);

			} catch (e) {
				if (rTComment)  console.log('texture error', e);
				var texd = twgl.createTexture(gl,
					{
						internalFormat: gl.RGBA32F,
						format: gl.RGBA,
						type: gl.FLOAT,
						src: Array(36).fill(0, 0),
						//						width: 9 //4*9, 36 floats
						width: 1 //4 floats (audio + video!)
					});
			}


			//texture di audiodati!!


			//FLOAT DATA TEXTURE FOR AUDIO
			//FLOAT DATA TEXTURE FOR AUDIO


			//FLOAT DATA posizione oggetti!!
			//FLOAT DATA posizione oggetti!!



			for (let i = 0; i < objectData.texObPos.length; i += 8) {
				for (let j = 0; j < 4; j++)
					objectData.texObPos[j + 4] = objectData.texObPos[j]; //la seconda quaterna conserva i dati pregressi
				let N = objectData.texf1[i] * time[0]; //numero elementi isola normalizzato*20
				objectData.texObPos[i] = Math.sin(N);
				objectData.texObPos[i + 1] = Math.cos(N);
				objectData.texObPos[i + 2] = Math.sin(N) * 2;
				objectData.texObPos[i + 3] = 1; //Dato extra da vedere cosa farci
			}

			//			if (rTComment)  console.log('klikkio');

			//Texture con le posizione oggetto!!

			un.texOP = twgl.createTexture(gl,
				{
					internalFormat: gl.RGBA32F,
					format: gl.RGBA,
					type: gl.FLOAT,
					src: objectData.texObPos, //il buffer dati
					width: 2 //4*N oggetti, 32 floats
				});
			//FLOAT DATA posizione oggetti!!
			//FLOAT DATA posizione oggetti!!



			twgl.resizeCanvasToDisplaySize(gl.canvas);
			gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
			gl.enable(gl.DEPTH_TEST);
			// gl.enable(gl.CULL_FACE);
			// gl.cullFace(gl.FRONT_AND_BACK);
			gl.clearColor(0, 0, 0, 1);
			gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
			//the rotation increment

			//ISOLA SCELTA da fuori
			un.info2[4] = rToggler.isles[1];

			//The UNIFORMS 			
			let unif = {
				u_vc: rToggler.v, //controlli per il vertex shader
				u_fc: rToggler.f,	//controlli per il fragment shader
				u_time: un.time,
				u_durata: un.durata,
				u_fade: fade, //in quanto signals
				u_period: un.period, //i periodi
				u_tex1: un.tex1, //oggetto
				u_tex2: un.tex2,
				u_texf1: un.texf1,
				u_texf2: un.texf2,
				u_texf3: un.texf3,
				u_texOP: un.texOP, //float data posizione oggetti
				u_texd: texd, //float data texture (audio)
				u_nrect: vd.nrect, //WEBCAM: track totale
				u_crect: vd.crect, //WEBCAM: track colore
				u_npos: vd.npos, //WEBCAM: Posizione tracker
				u_info1: un.info1, //grandezza dell'oggetto w/h, diagonale, distanza massima pixel->centro isola;
				u_info2: un.info2, //isole: numero minimo, massimo elementi, numero totale di elementi, numero isole, isola scelta

				u_mat: m4.identity(),
				u_islesN: objectData.islands.length
			}


			//			eye=[0,0,0];

			//CAMERA
			//CAMERA

			//MOUSE CONTROLLER matrix e TRACK CONTROLLER matrix:

			//eye movement according to motion


			//scrive sul canvas
			//			tt.t3("eye : " + eye[0].toFixed(2) + " " + eye[1].toFixed(2) + " " + eye[2].toFixed(2) + " tar: " + target[0].toFixed(2) + " " + target[1].toFixed(2) + " " + target[2].toFixed(2));

			//######## MANCA PARTE GESTURE 

			//TRACKER WEBCAM
			//posizione eye x,y,z in base al tracker - eye controller
			//			ct.eyetrack[0] = (ct.fak * unif.u_npos[4] - .5) * fade[1];
			//			ct.eyetrack[1] = (ct.fak * unif.u_npos[5] - .5) * fade[1];
			//			ct.eyetrack[2] = (-unif.u_npos[6]) * fade[1];
			//TRACKER WEBCAM

			//MOUSE
			//MOUSE

			//			ct.eye[2] = ct.radius + mouseController.magn * ct.radius * (fade[1] | 1);//wheel controller da -1 a +1, fade1 or 1 indica che sarà


			let ll = globals.LatLong; //latitude and longitude of the sphere
			let mtx = [m4.identity(), m4.identity()];
			//eye rotation matrix around object
			if (rToggler.c & 0b10000000) {
				let dl = globals.PI / 360;

				if (mouseController.dxy[0] > 0) ll[0] += dl;
				if (mouseController.dxy[0] < 0) ll[0] -= dl;
				if (mouseController.dxy[1] > 0) ll[1] -= dl;
				if (mouseController.dxy[1] < 0) ll[1] += dl;

				//				ll[0]+=dl;

				//aggiustamento sferiche!
				if (ll[0] >= globals.PI2) ll[0] -= globals.PI2;
				if (ll[0] <= 0) ll[0] += globals.PI2;
				if (ll[1] >= globals.PI2) ll[1] -= globals.PI2;
				if (ll[1] <= 0) ll[1] += globals.PI2;

				mtx[0] = m4.rotationX(ll[1]);
				mtx[1] = m4.rotationY(ll[0]);
				//				let xmat = m4.rotationY(ll[0]);
				//				let ymat = m4.rotationY(ll[1]);
				//				//Aggiungiamo i cambiamenti dovuti al mouse!	
				//				var eyematrix = m4.multiply(xmat, ymat); //creates translation matrix from mouse OR track controller

				//				if (rTComment)  console.log('eye rotation', ll);
			}

			//posizione occhio normalizzato
			//			let ey=[];
			//
			//			//posizione sul globo normalizzata
			//			ey[0] = Math.cos(ll[0]) * Math.sin(ll[1]);
			//			ey[1] = Math.sin(ll[0]) * Math.sin(ll[1]);
			//			ey[2] = Math.cos(ll[1]);


			//posizione occhio finale prima della trasformazione rotativa

			//MOVIMENTO ROLL OGGETTO
			//MOVIMENTO ROLL OGGETTO
			//movimento X time[4] 0->PI
			if (rToggler.c & 0b100) {

				//				if (rTComment)  console.log(`rquad rtogler ${rToggler.c}`);

				let dx = un.info1[0] * .9;
				let dy = un.info1[1] * .6;

				let hw = dx / 2; //half width
				let hh = dy / 2; //half height

				let sint1 = Math.cos(time[1] * Math.PI * 10); //time[1] va da 0->1

				let posx = fade[2] * ((dx * un.time[1]) - hw); //posizione x dell'avanzamento suono;
				let posy = fade[2] * (sint1 * hh); //posizione y target su e giù

				let ddx = posx / dx; //posizione x normalizzato
				let ddy = posy / dy; //posizione y normalizzato
				let ddz = Math.sqrt(ddx * ddx + ddy * ddy); //distanza dal centro

				let posz = rd - fade[2] * ((rd * .8) * ddz + rd * .25 + 2.2 * Math.sin(un.time[1] * Math.PI * 10));


				//				ct.eye[0] = posx * 1.4;
				//				ct.eye[1] = -posy * 1.4;
				//				ct.eye[2] = posz;
				//
				//				ct.target[0] = posx;
				//				ct.target[1] = posy;
				//				ct.target[2] = 0;
				//
				//Avvicinamento
				rTowards0(ct.eye, [posx * 1.4, -posy * 1.4, posz], 0.01);
				//Avvicinamento
				rTowards0(ct.target, [posx, posy, 0], 0.01);

			} else {
				//eye
				rTowards0(ct.eye, [0, 0, rd], .01);
				//target
				rTowards0(ct.target, [0, 0, 0], .01);
			}
			//			tt.t1("eye z: " + eye[2].toFixed(2));
			//MOVIMENTO ROLL OGGETTO
			//MOVIMENTO ROLL OGGETTO
			//			if (rTComment)  console.log (`Logos ${ct.eye}`);


			//occhio, rotazione in base alla matrice sopra SI PRESUPPONE che origine sia 0,0!!
			//			m4.transformPoint(mtx[0], ey, ey);
			//			m4.transformPoint(mtx[1], ey, ct.eye);


			let csar = mouseController.csar; //sin, cos, angolo, raggio dal centro
			//			var scd = [csar[0] * csar[3] * ct.fak, csar[1] * csar[3] * ct.fak]; //scarto direzione x e y basati su cosa e sina 
			var scd = [mouseController.rotx, mouseController.roty]; //scarto direzione x e y basati su cosa e sina 




			// mouse - movimento diretto del target
			if (rToggler.c & 0b010000) {
				let faktorX = Math.abs(mouseController.dxy[0] * 0.001);
				let faktorY = Math.abs(mouseController.dxy[1] * 0.001);

				if (mouseController.dxy[0] > 0) ct.target[0] += (faktorX);
				if (mouseController.dxy[0] < 0) ct.target[0] -= (faktorX);
				if (mouseController.dxy[1] > 0) ct.target[1] -= (faktorY);
				if (mouseController.dxy[1] < 0) ct.target[1] += (faktorY);
				//				if (rTComment)  console.log('eye 1', rToggler.c, ct.target);
			}

			//eye mouse - movimento diretto eye
			if (rToggler.c & 0b100000) {
				let faktorX = Math.abs(mouseController.dxy[0] * 0.001);
				let faktorY = Math.abs(mouseController.dxy[1] * 0.001);

				if (mouseController.dxy[0] > 0) ct.eye[0] += (faktorX);
				if (mouseController.dxy[0] < 0) ct.eye[0] -= (faktorX);
				if (mouseController.dxy[1] > 0) ct.eye[1] -= (faktorY);
				if (mouseController.dxy[1] < 0) ct.eye[1] += (faktorY);
				//				if (rTComment)  console.log('eye 2', rToggler.c, ct.eye);
			}

			//TRACKER WEBCAM
			//			ct.targettrack[0] = 0;
			//			ct.targettrack[1] = 0;
			//			ct.targettrack[2] = 0;
			//TRACKER WEBCAM
			//########




			unif.u_mat = m4.identity(); //Matrice nel vertex shader che sposta la camera!

			//CAMERA
			//CAMERA

			//OBJECT
			//OBJECT - Cambiamenti nella matrix che muove l'oggetto!!

			//++++++++++++++++++++++++++++++++
			//++++++++++++++++++++++++++++++++
			//object mouse (rotation around object)

			//MOUSE MATRIX
			var objectMouseMatrix;


			if (rToggler.c & 0b1000000) {
				ct.objectmouse[3] = scd[0]; //rotx in base a mousecontrolle cos
				ct.objectmouse[4] = scd[1]; //roty in base a mousecontrolle sin + ritorno alle origini

				objectMouseMatrix = (m4.multiply(
					m4.rotationY(ct.objectmouse[3]),
					m4.rotationX(ct.objectmouse[4])
				));

			} else {
				ct.objectmouse[3] = 0; //
				ct.objectmouse[4] = 0; //
				objectMouseMatrix = m4.identity();
			}



			//MOUSE MATRIX



			//matrice da moltiplicare per ruotare il quadrato!
			//			unif.u_mat = (m4.multiply(m4.rotationY(param.globals.PI+((unif.u_npos[4]) * param.globals.PI2 / 1) * fade[1]), m4.rotationX(param.globals.PI+((unif.u_npos[5]) * param.globals.PI2 / 1) * fade[1])));
			unif.u_mat = m4.multiply(objectMouseMatrix, ct.objectmatrix);
			//			if (rTComment)  console.log(unif.u_mat);

			//Per direzionare il suono!
			Tone.Listener.set({
				//				positionX: ct.eye[0],
				//				positionY: ct.eye[1],
				//				positionZ: ct.eye[2],
				//				//				positionZ: 0,
				//				forwardX: ct.target[0],
				//				forwardY: ct.target[1],
				//				forwardZ: ct.target[2],
				positionX: 0,
				positionY: 0,
				positionZ: ct.eye[2],
				//				positionZ: 0,
				forwardX: 0,
				forwardY: 0,
				forwardZ: ct.target[2],
			});

			const up = [0, 1, 0];
			const camera = m4.lookAt(ct.eye, ct.target, up, un.world.viewInverse);
			const view = m4.inverse(camera);


			//moltiplica il view projection in base all'ottica della camera
			m4.multiply(globals.projection, view, un.world.viewProjection);
			//OGGETTI GL
			//OGGETTI GL


			//SCRITTURE SU CANVAS ETC
			//SCRITTURE SU CANVAS ETC

			if (rToggler.c & 0b01) {

				tt.t1(`transport dur and pos: ${pos.toFixed(2)} ${Tone.Transport.rPos.dur.toFixed(2)} || eye x:${ct.eye[0].toFixed(2)} y:${ct.eye[1].toFixed(2)} z:${ct.eye[2].toFixed(2)} | target x:${ct.target[0].toFixed(2)} y:${ct.target[1].toFixed(2)} z:${ct.target[2].toFixed(2)}`);

				let ts = "TIME: ";
				time.forEach((v, i) => {
					ts += `[${i}]: ${v.toFixed(2)} `;
				});
				let ps = "PERIOD: ";
				period.forEach((v, i) => {
					ps += `[${i}]: ${v.toFixed(2)} `;
				});

				tt.t2(ps);
				tt.t3(ts);
			}


			//SCRITTURE SU CANVAS ETC
			//SCRITTURE SU CANVAS ETC



			//			if (rTComment)  console.log(unif);

			objectData.oggetti.forEach(function(ob, key) {
				{
					let glsblock = ob.glsBlock;
					gl.useProgram(programInfo.program);

					twgl.setUniformBlock(gl, programInfo, un.world.viewInfo);
					twgl.bindUniformBlock(gl, programInfo, un.material);

					twgl.bindUniformBlock(gl, programInfo, un.world.lightInfos[0]);
					twgl.bindUniformBlock(gl, programInfo, un.model);

					twgl.setUniforms(programInfo, unif);

					twgl.setBuffersAndAttributes(gl, programInfo, glsblock.bufferInfo);

					twgl.drawBufferInfo(gl, glsblock.bufferInfo,gl.TRIANGLE_STRIP);
				}
			});


			//OGGETTI GL
			//OGGETTI GL

		}
		//		if (rTComment)  console.log(pos.toFixed(2), param.iData.imageData.duration);
		if (pos >= Tone.Transport.rPos.dur) {
			app.animationReset();
		}

		if (isRunning) requestAnimationFrame(this.render.bind(this)); //razlozeno tle: https://stackoverflow.com/questions/6065169/requestanimationframe-with-this-keyword

		/**Statistiche nel caso siamo in testing mode*/
		if (rToggler.c & 0b01) this.parameters.stats.end();
	},
	/**
	 * le cose che cambiano
	 * @returns {undefined}
	 */
	change: function() {

	},
	/**
	 * scrive il numero sul context!
	 */
	writeNumber: function(s) {
		let ctx = this.parameters.iData.imageContext;
		ctx.fillStyle = "White";
		ctx.font = "normal 12pt Arial";
		ctx.fillText(s, 10, 22);
	}
};
export { rQuad };
